


















import {Vue, Component} from 'vue-property-decorator';
import Footer from '@/components/Views/Home Page/Footer.vue';
import FooterLinks from '@/components/Views/Home Page/FooterLinks.vue';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {Mixins} from 'vue-property-decorator';
import CustomerOrderCard from '@/components/Views/Customer/CustomerOrderCard.vue';
import CancelOrderDialog from '@/components/Views/Customer/CancelOrderDialog.vue';
import {ORDER_STATUS} from '@/common';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';

@Component({
    components: {
        CancelOrderDialog,
        CustomerOrderCard,
        FooterLinks,
        Footer,
    },
})
export default class CustomerOrders extends Mixins(UserRoleMixin, ScreenSizeMixin) {
    private loading = true;
    private blankState = false;
    private orders: any[] = [];

    public mounted() {
        this.getMyOrders();
    }

    public created() {
        this.getMyOrders();
    }

    public onCancel(order) {
        (this.$refs.cancelOrderDialog as any).openWith(order);
    }

    public cancelComplete() {
        this.getMyOrders();
        (this.$refs.cancelOrderDialog as any).open = false;
    }
    public get loaderSize() {
        return this.largestDimension() / 4;
    }
    public async getMyOrders() {
        const {Purchaser, Order, Booking, User} = this.$FeathersVuex;
        const purchaser = await Purchaser.find({
            query: {
                user: this.user._id,
            },
        });
        if (purchaser.total === 0) {
            this.blankState = true;
            this.loading = false;
        } else {
            const orders = await Order.find({
                query: {
                    purchaser: purchaser.data[0],
                    status: {
                        $in: [ORDER_STATUS.PLACING, ORDER_STATUS.PAID, ORDER_STATUS.ACCEPTED, ORDER_STATUS.CANCELLED, ORDER_STATUS.CANCELLING, ORDER_STATUS.FULFILLED, ORDER_STATUS.REQUIRES_REVIEW],
                    },
                },
            });
            this.blankState = orders.total === 0;
            this.orders = orders.data;
            this.loading = false;
        }
    }
}
